import React from 'react';
import { ToastProvider, useToast } from '../../../design-system/components/desktop';
import { registerToastHandle } from '../../../utils/toast';

/**
 * ThemeToastContainer.
 *
 * Same name, same file path, same usage in App.js: `<ThemeToastContainer />`
 * with no props, mounted once near the root. Only the inside changed, from
 * react-toastify to the design system's `Toast`.
 *
 * NO THEME PROP ANY MORE, AND THAT IS THE POINT. react-toastify needed to be
 * told `theme={isDarkMode ? 'dark' : 'light'}`, which is a second source of
 * truth for the theme and one more thing that can drift out of step with
 * `.dark-theme` on <html>. The design system's toast reads semantic variables,
 * so it is already correct in both themes with nothing passed.
 *
 * The provider renders its own region through a portal on document.body, so
 * mounting it here, with no children, gives exactly the previous behaviour:
 * a notification surface parked at the root that every part of the app can
 * reach through `showToast`.
 */

/** Hands the provider's imperative API to the `showToast` module singleton. */
function ToastHost() {
  const api = useToast();

  React.useEffect(() => registerToastHandle(api), [api]);

  return null;
}

const ThemeToastContainer = () => (
  <ToastProvider>
    <ToastHost />
  </ToastProvider>
);

export default ThemeToastContainer;
